// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.8_webpack@5.111.1_esbuild@0.28.1_postcss@8.5.28_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1024px) and (max-width: 1279px) {
  :root {
    --nav-bar-height: 40px;
  }
}

@media (min-width: 1024px) {
  #sensor-selected-container {
    width: max-content;
    padding: 0px 10px;
  }

  #fullscreen-icon {
    display: none;
  }

  #menu-launches,
  #menu-record,
  #menu-color-scheme,
  #social,
  #fastCompSettings {
    display: block;
  }

  .top-menu-icons>a {
    padding: 0px 10px;
  }

  .search-icon-search-on {
    transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
  }

  .top-menu-icons img {
    width: 25px;
    height: 25px;
  }

  #search-close {
    padding: 0px 6.25%;
    font-size: 24px;
  }

  /* TODO: Account for the bottom bar being minimized */
  #search-results {
    overflow-x: hidden;
    overflow-y: auto;
    display: none;
    position: absolute;
    right: 0px;
    width: 360px;
    background: var(--color-dark-background) !important;
    z-index: 1;
    top: var(--top-menu-height);
    bottom: var(--bottom-menu-top);
    max-height: calc(100% - var(--top-menu-height) - max(var(--bottom-menu-top), var(--search-box-bottom) + var(--bottom-menu-top)) + 3px);
    border-width: 0px 0px 5px 5px;
    border-style: solid;
    border-color: var(--color-dark-border);
    border-top: 5px solid var(--color-dark-border);
    padding-top: 0px;
  }

  .share-icons {
    position: absolute;
    left: 0px;
    z-index: 1;
    width: 50px;
    height: 50px;
    padding: 9px;
    background: var(--color-dark-background) !important;
  }

  .share-up {
    transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));
    top: 0px !important;
  }

  #time-machine-menu {
    padding-left: 35px;
    color: white;
    background: var(--color-dark-background);
    top: 50px;
    right: 0px;
    z-index: 100;
    position: absolute;
    overflow: auto;
    width: 100%;
    border-width: 0px 0px 5px 0px;
    border-style: solid;
    border-color: var(--color-dark-border);
  }

  #obfit-menu {
    width: 500px;
  }

  .search-slide-down {
    width: 355px;
    /* This should match the #search-results */
  }

  .search-slide-up {
    width: 0px;
  }

  #layers-hover-menu {
    top: var(--top-menu-height);
    padding: 5px;
  }

  .Square-Box {
    width: 25px;
    height: 25px;
  }

  #sat-infobox {
    bottom: var(--bottom-menu-height);
    margin-top: 25px;
    right: 0px;
    width: 360px;
    max-height: 60%;
  }

  .satinfo-fixed:after {
    content: '';
    height: calc(var(--bottom-menu-height) + 15px);
    display: block;
  }

  .sat-info-value {
    float: right;
    width: 220px;
    padding: 0px 25px;
    text-align: center;
  }

  .truncate-search {
    width: 200px;
  }

  #version-text {
    top: unset;
    bottom: 2rem;
    left: 3rem;
  }
}`, "",{"version":3,"sources":["webpack://./public/css/responsive-lg.css"],"names":[],"mappings":"AAAA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;IAKE,cAAc;EAChB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,wEAAwE;EAC1E;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA,qDAAqD;EACrD;IACE,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,mDAAmD;IACnD,UAAU;IACV,2BAA2B;IAC3B,8BAA8B;IAC9B,sIAAsI;IACtI,6BAA6B;IAC7B,mBAAmB;IACnB,sCAAsC;IACtC,8CAA8C;IAC9C,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,mDAAmD;EACrD;;EAEA;IACE,wEAAwE;IACxE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,SAAS;IACT,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,sCAAsC;EACxC;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,0CAA0C;EAC5C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,2BAA2B;IAC3B,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,8CAA8C;IAC9C,cAAc;EAChB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,UAAU;EACZ;AACF","sourcesContent":["@media (min-width: 1024px) and (max-width: 1279px) {\n  :root {\n    --nav-bar-height: 40px;\n  }\n}\n\n@media (min-width: 1024px) {\n  #sensor-selected-container {\n    width: max-content;\n    padding: 0px 10px;\n  }\n\n  #fullscreen-icon {\n    display: none;\n  }\n\n  #menu-launches,\n  #menu-record,\n  #menu-color-scheme,\n  #social,\n  #fastCompSettings {\n    display: block;\n  }\n\n  .top-menu-icons>a {\n    padding: 0px 10px;\n  }\n\n  .search-icon-search-on {\n    transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n  }\n\n  .top-menu-icons img {\n    width: 25px;\n    height: 25px;\n  }\n\n  #search-close {\n    padding: 0px 6.25%;\n    font-size: 24px;\n  }\n\n  /* TODO: Account for the bottom bar being minimized */\n  #search-results {\n    overflow-x: hidden;\n    overflow-y: auto;\n    display: none;\n    position: absolute;\n    right: 0px;\n    width: 360px;\n    background: var(--color-dark-background) !important;\n    z-index: 1;\n    top: var(--top-menu-height);\n    bottom: var(--bottom-menu-top);\n    max-height: calc(100% - var(--top-menu-height) - max(var(--bottom-menu-top), var(--search-box-bottom) + var(--bottom-menu-top)) + 3px);\n    border-width: 0px 0px 5px 5px;\n    border-style: solid;\n    border-color: var(--color-dark-border);\n    border-top: 5px solid var(--color-dark-border);\n    padding-top: 0px;\n  }\n\n  .share-icons {\n    position: absolute;\n    left: 0px;\n    z-index: 1;\n    width: 50px;\n    height: 50px;\n    padding: 9px;\n    background: var(--color-dark-background) !important;\n  }\n\n  .share-up {\n    transition: 300ms var(--kt-easing-default, cubic-bezier(0.4, 0, 0.2, 1));\n    top: 0px !important;\n  }\n\n  #time-machine-menu {\n    padding-left: 35px;\n    color: white;\n    background: var(--color-dark-background);\n    top: 50px;\n    right: 0px;\n    z-index: 100;\n    position: absolute;\n    overflow: auto;\n    width: 100%;\n    border-width: 0px 0px 5px 0px;\n    border-style: solid;\n    border-color: var(--color-dark-border);\n  }\n\n  #obfit-menu {\n    width: 500px;\n  }\n\n  .search-slide-down {\n    width: 355px;\n    /* This should match the #search-results */\n  }\n\n  .search-slide-up {\n    width: 0px;\n  }\n\n  #layers-hover-menu {\n    top: var(--top-menu-height);\n    padding: 5px;\n  }\n\n  .Square-Box {\n    width: 25px;\n    height: 25px;\n  }\n\n  #sat-infobox {\n    bottom: var(--bottom-menu-height);\n    margin-top: 25px;\n    right: 0px;\n    width: 360px;\n    max-height: 60%;\n  }\n\n  .satinfo-fixed:after {\n    content: '';\n    height: calc(var(--bottom-menu-height) + 15px);\n    display: block;\n  }\n\n  .sat-info-value {\n    float: right;\n    width: 220px;\n    padding: 0px 25px;\n    text-align: center;\n  }\n\n  .truncate-search {\n    width: 200px;\n  }\n\n  #version-text {\n    top: unset;\n    bottom: 2rem;\n    left: 3rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
